import { motion } from 'framer-motion';
import { m } from '~/paraglide/messages.js';

type ThinkingMessageProps = {
  thinking?: string;
};

export function ThinkingMessage({ thinking }: ThinkingMessageProps) {
  return (
    <motion.div
      key="thinking"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="w-full flex items-center gap-2 text-sm text-gray-400 py-2"
    >
      <div className="flex items-center gap-1">
        <img
          src="/thinking.gif"
          alt={m['chat.animation_alt']()}
          className="w-8 h-8"
        />
        <span className="bg-gradient-to-r from-white to-[#4D4D4D] bg-clip-text text-transparent font-bold text-sm">
          {!thinking ? m['chat.thinking']() : thinking}
        </span>
      </div>
    </motion.div>
  );
}
